import React from 'react';
import MuiDivider from '@mui/material/Divider';
import { designTokenToColor } from '@src/utils/colors';

import type { DividerProps } from './interface';

const SX = {
  borderColor: designTokenToColor('controls.backing+line'),
  '&.MuiDivider-thick': {
    borderWidth: '10px'
  }
};

export function Divider(props: DividerProps) {
  const {
    inset,
    size = 'small',
  } = props;

  const cx = size === 'large' ? 'MuiDivider-thick' : 'MuiDivider-thin';

  return <MuiDivider sx={SX} className={cx} variant={inset ? 'middle' : 'fullWidth'} />
}
